<template>
  <div v-if="reviewSite">
    <h1>Review site</h1>
    <v-btn :to="{name:'reviewSites'}">
      <v-icon>chevron_left</v-icon>Review sites
    </v-btn>
    <v-form ref="formReviewSite" v-model="valid" lazy-validation>
      <v-text-field label="Id" v-model="reviewSite.id" v-if="computedEditing" outline readonly />
      <v-text-field
        label="Name"
        v-model="reviewSite.name"
        :rules="valueRules"
        :readonly="computedEditing"
        outline
      />
      <v-text-field label="Url" v-model="reviewSite.url" :rules="valueRules" outline />
      <v-btn @click="saveReviewSite">
        <v-icon>save</v-icon>Save
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ReviewSite",
  metaInfo() {
    return {
      title: "Review site",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEditing() {
      return this.$route.params.id ? true : false;
    }
  },
  data() {
    return {
      reviewSite: null,
      valid: false,
      valueRules: [v => !!v || "Value is required"]
    };
  },
  methods: {
    fetchReviewSite() {
      nbmlaw
        .get(`/cors/admin/directory/reviewSites/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.reviewSite = response.data;
        })
        .catch(() => {});
    },
    saveReviewSite() {
      if (this.$refs.formReviewSite.validate()) {
        if (this.$route.params.id) {
          this.updateReviewSite();
        } else {
          this.createReviewSite();
        }
      }
    },
    updateReviewSite() {
      nbmlaw
        .put(
          `/cors/admin/directory/reviewSites/${this.$route.params.id}`,
          this.reviewSite
        )
        .then(() => {
          this.$router.push({ name: "reviewSites" });
        })
        .catch(() => {});
    },
    createReviewSite() {
      nbmlaw
        .post(`/cors/admin/directory/reviewSites`, this.reviewSite)
        .then(() => {
          this.$router.push({ name: "reviewSites" });
        })
        .catch(() => {});
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchReviewSite();
        } else {
          this.reviewSite = {};
        }
      }
    }
  }
};
</script>
